import { IHeadlineProperties } from '@vfde-brix/ws10/headline';

/**
 * Gets the properties for a headline component
 */
export const getHeadlineUpdatedProps = (text: string): Partial<IHeadlineProperties> => ({
    stdContent: text,
});
